export class RepositoryError extends Error {
  constructor(message, details = {}) {
    super(message);
    this.name = 'RepositoryError';
    this.details = details;
  }
}
